export default {
  'front': [
    {
      'id': 1,
      'name': 'React',
      'icon': 'devicon-react-original',
      'desc': 'Component architecture with Context API state management'
    },
    {
      'id': 2,
      'name': 'TypeScript + Webpack + Babel',
      'icon': 'devicon-sass-original',
      'desc': 'Typed code, bundling, transpilation, and production builds'
    },
    {
      'id': 3,
      'name': 'Semantic UI React',
      'icon': 'devicon-css3-plain',
      'desc': 'UI primitives and layout components'
    }
  ],

  'lib': [
    {
      'id': 4,
      'name': 'Keen Slider',
      'link': 'https://keen-slider.io/',
      'desc': '/keen-slider'
    },
    {
      'id': 5,
      'name': 'React Router',
      'link': 'https://github.com/remix-run/react-router',
      'desc': '/react-router-dom'
    },
    {
      'id': 6,
      'name': 'Nivo Charts',
      'link': 'https://nivo.rocks/',
      'desc': '/@nivo/bar + /@nivo/pie'
    },
    {
      'id': 7,
      'name': 'Mapbox GL + React Map GL',
      'link': 'https://docs.mapbox.com/mapbox-gl-js/',
      'desc': '/mapbox-gl + /react-map-gl'
    },
    {
      'id': 8,
      'name': 'React Markdown',
      'link': 'https://github.com/remarkjs/react-markdown',
      'desc': '/react-markdown'
    },
    {
      'id': 9,
      'name': 'Emoji Mart Data',
      'link': 'https://github.com/missive/emoji-mart',
      'desc': '/@emoji-mart/data'
    }
  ]
}
